import axios from 'axios';

const getBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    return 'http://localhost:8001/api';
  }
  return 'https://bholikoitahari.com/api';
};

// ── Axios instance ────────────────────────────────────────────────────────────
const api = axios.create({
  baseURL: getBaseUrl(),
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' },
});

// ── Request interceptor: attach JWT ──────────────────────────────────────────
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// ── Response interceptor: handle 401 globally ────────────────────────────────
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// ── Auth ──────────────────────────────────────────────────────────────────────

export const loginUser = async (credentials) => {
  const res = await api.post('/auth/login', credentials);
  return res.data;
};

export const registerUser = async (data) => {
  const res = await api.post('/auth/register', data);
  return res.data;
};

export const logoutUser = async () => {
  const res = await api.post('/auth/logout');
  return res.data;
};

// ── Editor Profile ────────────────────────────────────────────────────────────

/**
 * Update editor's name, email, and optionally avatar (as multipart/form-data).
 * Pass a FormData object so the image file is sent correctly.
 *
 * Usage:
 *   const formData = new FormData();
 *   formData.append('name', 'Ram Bahadur');
 *   formData.append('email', 'ram@example.com');
 *   formData.append('avatar', fileObject);   // optional
 *   await updateEditorProfile(formData);
 */
export const updateEditorProfile = async (formData) => {
  const res = await api.put('/editor/profile', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
};

/**
 * Change editor's password.
 *
 * Usage:
 *   await updateEditorPassword({ currentPassword: '...', newPassword: '...' });
 */
export const updateEditorPassword = async ({ currentPassword, newPassword }) => {
  const res = await api.put('/editor/profile/password', {
    currentPassword,
    newPassword,
  });
  return res.data;
};

export default api;